import Component from "gia/Component";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.DOM.form = this.DOM.view.querySelector("form");

    this.events();
  }

  events() {
    for (let trigger of this.ref.trigger) {
      trigger.addEventListener("click", () => {
        this.ref.input[0].value = trigger.dataset.value;
        this.DOM.form.submit();
      });
    }
  }

  unmount() {}
}
